// extracted by mini-css-extract-plugin
export var numpadContainer = "_nc-1";
export var phoneButton = "_nc-0";